import { DohaChopaiDataType } from "~/interface/doha-chopai/doha-chopai";

export const filtereQuoteData = (quoteData: DohaChopaiDataType[]) => {
  return quoteData.length
    ? quoteData
        ?.filter((item) => item.audio_url !== null)
        .map((item) => {
          return {
            id: item.id,
            ref: item.ref,
            quote: item.text,
            author: item.rachayta,
            audio: item.audio_url,
          };
        })
    : [];
};
